import { z } from "zod"

export const emailSchema = z.string().email({ message: "Invalid email address" })

export const passwordComplexitySchema = z.string()
  .min(10, "Password must be at least 10 characters")
  .regex(/[A-Z]/, "Must include at least one uppercase letter")
  .regex(/[a-z]/, "Must include at least one lowercase letter")
  .regex(/\d/, "Must include at least one digit")
  .regex(/[^A-Za-z0-9]/, "Must include at least one special character")

export const loginPasswordSchema = z.string().min(8, { message: "Password must be at least 8 characters" })
